module.exports = __webpack_public_path__ + "img/store.81228795.svg";